import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { FiltersService } from 'src/app/core/services/filters/filters.service';
import { ColumnsUtilService } from 'src/app/core/services/uitls/columns-util/columns-util.service';
import { FilterUtilService } from 'src/app/core/services/uitls/filter-utilizer/filter-util.service';
import { FilterComponent } from 'src/app/shared/components/filter/filter.component';
import { AdminOrdersService } from '../../orders/services/orders/admin-orders.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';
import { ConfirmationBoxComponent } from 'src/app/shared/components/confirmation-box/confirmation-box.component';
import { handlePaginationChangeUtil } from 'src/app/core/services/uitls/navigation.utils';
import { BehaviorSubject } from 'rxjs';
import { tablesHeaderData } from 'src/app/shared/global/tablesHeaderData';

@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  styleUrl: './finance.component.scss',
})
export class FinanceComponent implements OnInit {
  filterDataInit = {};
  filterPage: string = 'FINANCE_ORDERS';
  filterParamsUrl = {};
  filterData;
  modelImg: boolean;
  imgPath: string;
  confirmMsg: string;
  disableExportBtn: boolean;
  saveDialogRef: MatDialogRef<AlertBoxComponent>;
  deleteDialogRef: MatDialogRef<ConfirmationBoxComponent>;
  isTotalRowsSelected: boolean;
  config: { id: string; itemsPerPage: any; currentPage: any; totalItems: any };
  totalRecords: number = 0;
  page: number = 1;
  page_size: number = 20;
  currentItemsPerPage: any;
  @ViewChild('goUp', { static: true }) contentPage: ElementRef;
  spinner: boolean;
  pageTitle: string = 'المالية';
  selectedRowsIndex: any[] = [];
  selectedRowsPK: any[] = [];
  selectedQuery: {};
  updatedOrders = new BehaviorSubject({});
  orderData = this.updatedOrders.asObservable();
  tableHeaderData = tablesHeaderData.FINANCE_ORDER_HEADER_DATA;
  orders: any[] = [];
  boolenObject: { accept: string; notAccept: string };
  constructor(
    private titleService: Title,
    private filter: FiltersService,
    private filterUtil: FilterUtilService,
    private route: ActivatedRoute,
    private adminOrder: AdminOrdersService,
    private matDialog: MatDialog,
    private router: Router,
    private columnsUtil: ColumnsUtilService
  ) {
    this.config = {
      id: 'myPagination',
      itemsPerPage: this.page_size,
      currentPage: this.page,
      totalItems: this.totalRecords,
    };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (Object.keys(params).length > 0) {
        this.filterParamsUrl = { ...params };
        this.filterDataInit = { ...params };
      }
    });
    this.getFinancesFilter();
    this.filterUtil.clearfilterParams(this.filterParamsUrl);
    this.filterUtil.clearfilterParams(this.filterDataInit);
    this.titleService.setTitle(' المالية | عاين');
    this.filter.changeSelectedFilter(this.filterDataInit);
    this.getOrdersByPage();
    this.columnsUtil.applyColumnsData(this.tableHeaderData);
    this.boolenObject = { accept: 'نعم', notAccept: 'لا' };
  }

  getFinancesFilter() {
    let params = {
      filter_page: this.filterPage,
    };
    this.filter.getFiltersData(params).subscribe(
      (data) => {
        this.filterData = data;
      },
      (error) => {
        console.error('error');
      }
    );
  }

  filterFormValues(event) {
    this.filterParamsUrl = event.filterParamsUrl;
    this.spinner = true;
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getOrdersByPage();
  }

  exportFinanceSheet() {
    let params = { ...this.filterParamsUrl };
    this.adminOrder.exportFinanceSheet(params).subscribe({
      next: (response) => {
        this.disableExportBtn = true;
        this.modelImg = true;
        this.confirmMsg = response.status;
        this.showAlertBox();
      },
      error: (error) => {
        this.modelImg = false;
        this.imgPath = '../../../../assets/images/svg/refusal-icon-admin.svg';
        this.confirmMsg = error.error.error;
        this.showAlertBox();
      },
    });
  }
  selectTotalRows(event) {
    this.isTotalRowsSelected = event;
    this.selectedQuery = { ...this.filterParamsUrl };
  }
  getOrdersByPage(ordering?) {
    // this.emptySelectedRows();
    this.isTotalRowsSelected = false;
    let params = { ...this.filterParamsUrl };

    if (ordering) {
      params['ordering'] = ordering;
    }
    params['page'] = this.config.currentPage;
    params['page_size'] = this.config.itemsPerPage;
    this.adminOrder.getFinanceOrdersByPage(params).subscribe(
      (data) => {
        this.loadOrders(data);
        this.updatedOrders.next(data.results);
      },
      (error) => {
        // this.handleBackendError(error);
      }
    );
  }
  loadOrders(data) {
    // this.spinner = false;
    this.orders = data.results;
    this.config['totalItems'] = data.count;
    this.currentItemsPerPage = data.results.length;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: this.filterParamsUrl,
      queryParamsHandling: '',
    });
  }
  getSelectedRow(event) {
    this.selectedRowsIndex = event.index;
    this.selectedRowsPK = event.id;
    this.isTotalRowsSelected = false;
  }
  changeToSpecific(event) {
    this.pageChanged(event);
  }

  pageChanged(event) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => (this.spinner = value),
      this.router,
      'page',
      event
    );
    this.config.currentPage = event;
    this.isTotalRowsSelected = false;
    this.getOrdersByPage();
  }
  pageSizeChanged(event) {
    handlePaginationChangeUtil(
      this.contentPage,
      (value: boolean) => (this.spinner = value),
      this.router,
      'page_size',
      event
    );
    this.config.itemsPerPage = event;
    this.getOrdersByPage();
  }
  onFilterTextBoxChanged() {
    this.config.currentPage = 1;
    this.config.itemsPerPage = 20;
    this.getOrdersByPage();
  }

  showAlertBox() {
    this.saveDialogRef = this.matDialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: this.modelImg,
        message: this.confirmMsg,
        imgPath: this.imgPath,
        button: 'تم',
      },
    });
  }
}
